const unMaskCepNo = (value) => {
    return value ? value.replace(/\D+/g, '').substring(1) : null
}

export default unMaskCepNo